<tiime-dialog (cancel)="cancel()">
  <span mat-dialog-title data-cy="create-document-category-title">Ajouter un espace Expert-comptable</span>
  <mat-dialog-content class="dialog-content" mat-dialog-content>
    <div class="icon-container">
      <img src="assets/icon_other_document.svg" alt="Icône création espace" />
      <mat-icon class="accountant-icon" fontSet="fontastic" fontIcon="icon-accountant-tag-fontastic-18"></mat-icon>
      <mat-icon class="add-icon" fontSet="fontastic" fontIcon="icon-ic-add"></mat-icon>
    </div>
    <span class="message">Cet espace est lié au dossier, et ne sera pas visible par votre client.</span>
    <tiime-input-container contentId="name" label="Nom de l'espace" required="true" [errorMessage]="nameErrorMessage">
      <input
        #nameInput
        id="name"
        type="text"
        placeholder="Nom de l'espace"
        [formControl]="nameControl"
        autocomplete="off"
        data-cy="create-document-category-name-input"
      />
    </tiime-input-container>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button
      tiime-button
      color="accent"
      strocked
      large
      [disabled]="nameControl.disabled"
      (click)="cancel()"
      data-cy="create-document-category-cancel-btn"
    >
      Annuler
    </button>
    <button
      tiime-button
      color="accent"
      large
      raised
      [disabled]="nameControl.disabled"
      (click)="createDocumentCategory()"
      data-cy="create-document-category-save-btn"
    >
      Ajouter
    </button>
  </mat-dialog-actions>
</tiime-dialog>
